import React, { useContext, useState } from 'react';
import { Form, FormikProvider, useFormik } from 'formik';
import * as Yup from 'yup';
import { backIcon } from '../../assets/images';
import { LoginFormContext } from '../../context/LoginFormContext';
import OTPInput from 'react-otp-input';
import { LoginService, VerifyOtpService } from '../../apis/auth';
import { useDispatch } from 'react-redux';
import { setAuthData } from '../../redux/actions/authActions';
import { tostS, tostE } from '../../config/toastConfig';
import { Button } from 'antd';

export default function Authenticate() {
  const { formData, setCurrentStep } = useContext(LoginFormContext);
  const dispatch = useDispatch();
  const [resending, setResending] = useState(false);

  const isEmail = formData.login_mode === 'email';
  const identifier = isEmail ? formData.email : `${formData.country_code} ${formData.mobile}`;

  const formik = useFormik({
    initialValues: { otp: '' },
    validationSchema: Yup.object({
      otp: Yup.string().required('OTP is required').min(6, 'OTP must be 6 digits')
    }),
    onSubmit: async (values) => {
      try {
        const payload = isEmail
          ? { email: formData.email, otp: values.otp }
          : { mobile: formData.mobile, otp: values.otp };

        const res = await VerifyOtpService(payload);
        if (res.status === 200 && res.data.success) {
          const respData = res.data.data;
          dispatch(setAuthData(respData.token, respData.user_details));
        } else {
          tostS(res.data.message);
        }
      } catch (error) {
        console.log(error);
      }
    }
  });

  const { values, setValues, errors, touched, handleSubmit, isSubmitting } = formik;

  const handleResend = async () => {
    setResending(true);
    try {
      const payload = isEmail
        ? { email: formData.email }
        : { mobile: formData.mobile, country_code: formData.country_code };

      const res = await LoginService(payload);
      if (res.status === 200 && res.data.success) {
        tostS('OTP resent successfully');
        setValues({ otp: '' });
      } else {
        tostE(res.data.message);
      }
    } catch (error) {
      tostE('Failed to resend OTP');
    } finally {
      setResending(false);
    }
  };

  return (
    <>
      <span className='login-back-icon mb-3' onClick={() => setCurrentStep(1)}>
        <img src={backIcon} alt="loginFormIcon" />
      </span>
      <h4>Enter Code</h4>
      <p>
        Please enter the 6 digit code we sent to <br />
        <b>{identifier}</b>
      </p>
      <FormikProvider value={formik}>
        <Form autoComplete='off' onSubmit={handleSubmit}>
          <div className='form-group mt-3'>
            <OTPInput
              value={values.otp}
              onChange={(otp) => setValues({ ...values, otp })}
              numInputs={6}
              renderInput={(props) => <input {...props} />}
              inputStyle="form-control otp-input"
              shouldAutoFocus
            />
            {touched.otp && errors.otp && (
              <div className='invalid-feedback'>{errors.otp}</div>
            )}
          </div>
          <div className='d-flex align-items-center justify-content-between mt-4'>
            <Button className='btn btn-paste' htmlType='submit' loading={isSubmitting}>
              Submit Code
            </Button>
            <Button
              type='link'
              loading={resending}
              onClick={handleResend}
              style={{ color: '#595C5C', padding: 0 }}
            >
              Resend Code
            </Button>
          </div>
        </Form>
      </FormikProvider>
    </>
  );
}
